import Dashboard from './Main/Dashboard'

export default Dashboard



// WEBPACK FOOTER //
// ./src/views/Dashboard/index.js